
































import { Component, Prop, Watch, Emit, Mixins } from "vue-property-decorator";
import { Point, Size, Rectangle, Vector, DraggingOffsets } from "../../../../../../base/domain/drawing";
import { AsyncRequestPool } from "../../../../../../base/utilities";
import { RectangleLayoutableMixin } from "../../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../../domain/editableFormat";
import { QuestionnaireGuidTree } from "../../../../../domain/questionnaire";
import { instanceOfIRectangleCoordinateEditable } from "../../../../../domain/editableFormat/properties";
import { IFormatPageLocatable, IFormatPageLocationResult } from "./IFormatPageLocatable";
import { QuestionnaireLocatableMixin } from "./mixins";
import { QuestionnaireFormatObject } from "../../../../../domain/questionnaire/constants";

@Component
export default class QuestionnaireFormatPageRelocator extends Mixins(QuestionnaireLocatableMixin, RectangleLayoutableMixin) implements IFormatPageLocatable {
  @Prop()
  objects: IFormatObjectEditable[];

  @Prop()
  selectedObjects: IFormatObjectEditable[];

  @Prop({ default: () => [] as QuestionnaireGuidTree<IFormatObjectEditable>[] })
  treeItems: QuestionnaireGuidTree<IFormatObjectEditable>[];

  $refs!: {
    tracker: HTMLDivElement,
  };

  data(): any {
    return {
      requestPool: new AsyncRequestPool<any, IFormatObjectEditable>(r => this.located(r.source)),
      source: null,
      offsets: new DraggingOffsets<IFormatObjectEditable>(null),
      requester: null,
    };
  }
  requestPool: AsyncRequestPool<any, IFormatObjectEditable>;
  source: IFormatObjectEditable;
  offsets: DraggingOffsets<IFormatObjectEditable>;
  requester: any;

  get isVisible(): boolean {
    return this.isLocating;
  }

  get isObjectVisible(): boolean {
    return this.requestPool.isProcessing
      && (this.isLocatorVisible);
  }

  get sourceHeight(): number {
    return this.source ? this.toObjectHeight(this.source) : 0;
  }

  get treeItemMap(): Map<IFormatObjectEditable, QuestionnaireGuidTree<IFormatObjectEditable>> {
    const treeItemMap = new Map<IFormatObjectEditable, QuestionnaireGuidTree<IFormatObjectEditable>>();
    this.treeItems.forEach(v => {
      treeItemMap.set(v.source, v);
    });
    return treeItemMap;
  }

  onPreMouseEntered(event: PointerEvent) {
    this.onMouseEntered(this.$refs.tracker, event);
    if (!this.isMouseLeftButtonPressed) {
      this.cancel(this.requester);
    }
  }

  onPreMouseMoved(event: PointerEvent) {
    const rect = this.$refs.tracker.getBoundingClientRect();
    if (rect.left <= event.clientX && event.clientX <= rect.right && rect.top <= event.clientY && event.clientY <= rect.bottom) {
      if (this.$refs.tracker.hasPointerCapture(event.pointerId)) {
        this.$refs.tracker.releasePointerCapture(event.pointerId);
      }
    }
    this.onMouseMoved(this.$refs.tracker, event);
  }

  onPreMouseLeaved(event: PointerEvent) {
    this.$refs.tracker.setPointerCapture(event.pointerId);
    this.onMouseLeaved(this.$refs.tracker, event);
  }

  toAppenderStyle(source?: IFormatObjectEditable) {
    const treeItem = this.treeItemMap.get(source);
    const offset = treeItem
      ? (treeItem.level * QuestionnaireFormatObject.Gap) + QuestionnaireFormatObject.Gap
      : 0;
    const color = this.isSelected(source)
      ? "transparent"
      : "#b147397f";
    return {
      "height": `${QuestionnaireFormatObject.Gap / 2}px`,
      "background-image": `linear-gradient(to right, transparent 0 ${offset}px, ${color} ${offset}px 100%)`,
    };
  }

  isSelected(source: IFormatObjectEditable): boolean {
    return source
      ? source.isSelected()
      : false;
  }

  toObjectStyle(index: number, source: IFormatObjectEditable) {
    const treeItem = this.treeItemMap.get(source);
    const offset = treeItem
      ? (treeItem.level * QuestionnaireFormatObject.Gap) + QuestionnaireFormatObject.Gap
      : 0;
    const color = this.isSelected(source)
      ? "transparent"
      : (this.locatingSource.index === index && this.locatingSource.isHitObject)
        ? "#0000FF3F"
        : "#bfbfbf7f";
    return {
      "height": `${this.toObjectHeight(source)}px`,
      "background-image": `linear-gradient(to right, transparent 0 ${offset}px, ${color} ${offset}px 100%)`,
    };
  }

  toGappedOffsets(index: number): DraggingOffsets<IFormatObjectEditable> {
    const objects = this.selectedObjects.slice(0, index);
    const height = objects.reduce((p, c) => p += this.toObjectHeight(c) + QuestionnaireFormatObject.Gap, 0);
    const object = this.selectedObjects[index];
    const ret = new DraggingOffsets(
      object,
      this.offsets.relocatingOffset.add(new Point(QuestionnaireFormatObject.Gap, height)),
      this.offsets.transformingRatesFromCenter,
      this.offsets.transformingVector,
    );
    return ret;
  }

  private toObjectHeight(source: IFormatObjectEditable): number {
    return instanceOfIRectangleCoordinateEditable(source)
      ? source.size().getValue().height
      : 0;  // TODO: 矩形以外の対応が必要になったら実装.
  }

  @Watch("isMouseLeftButtonPressed")
  onMouseLeftButtonClickedForLocator(newValue: boolean) {
    if (!newValue && this.isLocatorVisible) {
      if (0 <= this.locatingSource.index) {
        this.locatorRequestPool.processingRequest.source.result = this.locatorRequestPool.processingRequest.source.toRectangle();
      } else {
        this.cancel(this.requester);
      }
    }
  }

  @Watch("locatorRectangle")
  onLocatorRectangleUpdated(newValue: Rectangle, oldValue: Rectangle): void {
    this.onObjectRectangleUpdated(newValue, oldValue);
  }

  private onObjectRectangleUpdated(newValue: Rectangle, oldValue: Rectangle): void {
    if (!this.isObjectVisible) {
      return;
    }
    if (instanceOfIRectangleCoordinateEditable(this.source)) {
      const size = this.source.size().getValue();
      this.offsets = new DraggingOffsets(
        this.source,
        newValue.topLeft,
        new Rectangle(
          new Point(1, 1),
          new Size(newValue.width / size.width, newValue.height / size.height)
        ),
        new Vector(new Point(0, 0), new Point(0, 0)),
      );
    }
  }

  @Emit()
  located(located: IFormatObjectEditable): void {}

  async locateObject(requester: any, source: IFormatObjectEditable): Promise<IFormatPageLocationResult<Point>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.
    return {
      result: (await this.layoutRectangleObject(requester, source)).result.topLeft
    };
  }

  async locateObjectVertically(requester: any, source: IFormatObjectEditable): Promise<IFormatPageLocationResult<Point>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.
    return {
      result: (await this.layoutRectangleObject(requester, source)).result.topLeft
    };
  }

  async layoutRectangleObject(requester: any, source: IFormatObjectEditable, fixedAspectRatio: number = 0): Promise<IFormatPageLocationResult<Rectangle>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.
    if (!instanceOfIRectangleCoordinateEditable(source)) {
      throw new Error("矩形座標系ではありません.");
    }
    const size = source.size().getValue();
    return this.request<IFormatPageLocationResult<Rectangle>>(
      source,
      requester,
      () => this.locate(new Rectangle(new Point(0, 0), new Size(size.width, size.height))),
    );
  }

  async layoutLinearObject(requester: any, source: IFormatObjectEditable): Promise<IFormatPageLocationResult<Vector>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.線形オブジェクトはQuestionnaireでは存在しないはず.
    throw new Error("実装されてません.必要になるようなら実装してください.(今の所不要と判断.)");
  }

  async layoutPointsObject(requester: any, source: IFormatObjectEditable): Promise<IFormatPageLocationResult<Point[]>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.自由曲線オブジェクトはQuestionnaireでは存在しないはず.
    throw new Error("実装されてません.必要になるようなら実装してください.(今の所不要と判断.)");
  }

  private async request<T>(source: IFormatObjectEditable, requester: any, request: () => Promise<any>): Promise<T> {
    this.source = source;
    this.requester = requester;
    const result = await this.requestPool.request(source, requester, request) as T;
    this.source = null;
    this.requester = null;
    return result;
  }

  cancel(requester: any): void {
    if (this.requestPool.cancel(requester)) {
      // 実行中リクエストのキャンセル.
      this.cancelLocating();
    }
  }
}
